<template>
    <div id="ContainerPatientLetters">
        <div class="row">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle" 
                    v-bind:titlePrefix=" $t('Shared.FormGeneration')" 
                    v-bind:IsClinical="IsClinical"
                    v-bind:titleRef="'titleElementPatientLettersList'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>
            </div>
        </div>

        <b-row>
            <div class="col-sm-12 col-md-3">                      
                <MdButton
                    v-bind:Label= "$t('PatientLetters.AddLetter')" 
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="AddLetter"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_letter'">
                </MdButton>
            </div>

            <div class="col-sm-12 col-md-9 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input type="text" :dir="dirInput" class="form-control" v-model="SearchCriteria"
                            @keyup.enter="SearchLetter" />

                        <div class="input-group-append">
                            <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'" v-on:click="SearchLetter">
                            </MdButton>
                        </div>
                    </div>
                </div>
            </div>
        </b-row>

        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <b-row>
            <div class="col-12">
                <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="'tablePatientLetter'"
                    v-bind:FieldsDate="FieldsDateArr"
                    :viewIconEvent="PatientLetterView"                      
                    :editIconEvent="EditLetter"                        
                    v-bind:VisibleEditIcon="!this.isReadOnly"
                    v-bind:VisibleDownloadIcon="true"
                    :downloadIconEvent="DownloadLetter"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                </MdTable>
            </div>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
        </div>

        <LetterViewerModal
            :visible.sync = "letterViewerVisible"
            :value = "letterContents"
            :item = "editableItem"
        >

        </LetterViewerModal>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service'
import Utils from '@/common/utils'
import DBFunctions from '@/common/DBFunctions.js'
import NoteTemplates from '@/services/notetemplates.service'
import LetterViewerModal from './LetterViewerModal.vue'
import NoteTemplatesService from '@/services/notetemplates.service'

export default {
    name: 'PatientLettersList',
    mixins: [DBFunctions,],
    components: { LetterViewerModal },

    data() {
        return {
            InfoPatient:{},
            PatientTitle:{      
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:''
            }, 
            OptionsRightMenu:{
				visible:true,
				ItemsList:[],
				btnvisible:true,
				itemdisabled: false,
				PatientCode:''
			},
            IsClinical:false,
            isReadOnly: false,
            ShowMessageIsEmpty: false,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            EmployeeCode: this.$store.state.employeeCode,
            PatientCode: this.$route.params.id,
            SearchCriteria:'',
            fields: [
                { key: 'template', sortable: true, label: this.$t('Shared.Template'), class: 'text-rigth' },
                { key: 'therapist', sortable: true, label: this.$t('Shared.TherapistLabel'), class: 'text-rigth' },
                { key: 'sysDate', sortable: true, label: this.$t('Shared.Date'), class: 'text-rigth', formatter: value => { return value ? Utils.formatterDateToString(value) : ''} },
            ],
            items: [],
            FieldsDateArr: ['sysDate'],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            letterViewerVisible: false,
            editableItem: {},
            letterContents: ''
        }
    },

    methods: {
        getLetters() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                SearchCriteria: this.SearchCriteria,
                PatientCode: this.PatientCode,
            }
            NoteTemplates
                .getAll(parameters)
                .then((response) => {
                    if(response.status == '200'){
                        this.items = response.data;
                        
                        const header = JSON.parse(response.headers["x-pagination"]);
                        this.totalRows = header.TotalCount;
                    }

                    if(this.items.length === 0){
                        this.ShowMessageIsEmpty = true;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        SearchLetter() {
            this.currentPage = 1;
            this.getLetters();
        },

        AddLetter() {
            this.Mode = "Add";
            if(this.$route.name.includes('patient-letter')){   
                this.$router.push({ name: "patient-letter-add", params: { id: this.$route.params.id } });
            }
            else if(this.$route.name.includes('appointments-letter')){   
                this.$router.push({ name: "appointmentDB-letter-add", params: { id: this.$route.params.id, actId: this.$route.params.actId } });
            }
            else{		
                this.$router.push({ name: "Clinical-letter-add", params: { id: this.$route.params.id,recordid:this.$route.params.recordid } });       
            }
        },

        EditLetter(row) {
            const letterId = row.recId;      
            this.Mode = "Edit";
            sessionStorage.setItem('PatientLetterRecord', JSON.stringify(row));
            if(this.$route.name.includes('patient')){   
                this.$router.push({ name: "patient-letter-detail", params: { id: this.$route.params.id, letterId: letterId } });
            }
            else if(this.$route.name.includes('appointments-')){   
                this.$router.push({ name: "appointmentDB-letter-detail", params: { id: this.$route.params.id, letterId: letterId, actId: this.$route.params.actId } });
            }
            else{		
                this.$router.push({ name: "Clinical-letter-detail", params: { id: this.$route.params.id,letterId: letterId, recordid:this.$route.params.recordid } });       
            }
        },

        PatientLetterView(value) {
            this.$nextTick(() => {
                const data = {
                    headerId: value.headerId, 
                    templateCode: value.templateCode, 
                    id: value.recId,
                    patientCode: this.$route.params.id
                }
                NoteTemplatesService
                    .get(data)
                    .then((response) => {
                        if(response.status == '200') {
                            this.editableItem = value;
                            this.letterContents = response.data.letterContents;
                            this.letterViewerVisible = true;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    })
            });
            
        },

        DownloadLetter(value) {
            NoteTemplatesService
                .download(value.headerId, value.templateCode, value.recId)
                .then((response) => {
                    if (response.status == '200') {
                        const blob = new Blob([response.data], { type: 'application/html' });
                        const url = window.URL.createObjectURL(blob);

                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `lt_${value.templateCode}_${Utils.generateUUID()}.html`;
                        
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected(){

        },

        onFiltered(){

        },

        pageChanged (page) {
            this.currentPage = page;
            this.getLetters();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getLetters();
        },

        PopulatePatientTitle(){
            const { dob, dateFrom, dateTo, age, 
                programName, patientName, ageFormatted } = this.RegistrationInfo; // Destructure for easier access
        
            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	
            
            if(this.$route.name.includes('Clinical-')){ 
                if (programName) this.PatientTitle.programName = programName; 
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age === 0 ? "0" : age;
                if (ageFormatted) this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            } else if (this.$route.name.includes('patient-')) {         
                this.PatientTitle.programName = '';
                this.PatientTitle.dateFrom = '';
                this.PatientTitle.dateTo = '';
            }
        },
        

        async PopulateTitle() {
            if(!this.$route.name.includes('Clinical-')){  
                await this.GetPatientByCode();
            } else {      
                this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
                const { dateTo, age } = this.RegistrationInfo; // Destructure for easier access

                this.IsClinical = dateTo ? false : true;
                if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
            }
            
            this.PopulatePatientTitle();
        },

        async getCurrentAppointment() {
            const currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(currentAppointmentDB.transdate)} ${currentAppointmentDB.timein}`  
        },

        async GetPatientByCode(){
            this.infoList = await this.getInfoTitle(this.$route.params.id);
            if(this.infoList.length > 0){
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = this.infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;            
            }
        },
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('Clinical-') ? EnumService.ClinicalItems : 
            this.$route.name.includes('appointmentDB-') ? EnumService.AppointmentItems : EnumService.PatientItems;
		this.OptionsRightMenu.Mode = '';
		this.OptionsRightMenu.visible = true;    
		this.OptionsRightMenu.btnvisible = true;
        this.OptionsRightMenu.active_el = this.$route.name.includes('Clinical-') ? 'ClinicalLetters' : 'PatientLetters';
		this.$emit('getVisibleMenu', this.OptionsRightMenu);
        //this.isReadOnly = this.$store.state.isPatientActivitiesEHRReadOnly;

        await this.PopulateTitle();
        if (this.$route.name.includes('appointmentDB'))
            await this.getCurrentAppointment();
            
        this.getLetters();
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },
}
</script>